<template>
  <!-- 部分ui有padding需求，手动传递样式给padding -->
  <div class="padding">
    <div ref="slideWrap" class="slide__wrap">
      <div :style="itemStyle" ref="contentWrap" class="content__wrap">
        <slot />
      </div>
    </div>
    <div v-if="slideShow" @click="throttledArrowLeftClick">
      <slot v-if="$slots.left" name="left"></slot>
      <div v-else :class="['arrow__left ', index === 0 ? 'disabled' : '']">
        <i class="el-icon-arrow-left"></i>
      </div>
    </div>
    <div v-if="slideShow" @click="throttledArrowRightClick">
      <slot v-if="$slots.right" name="right"></slot>
      <div v-else :class="['arrow__right ', index === 1 ? 'disabled' : '']">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  props: {
    onceSlideWidth: {
      type: Number,
      default: 0
    },
    showArrow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slideShow() {
      return this.showArrow || this.content > this.container;
    },
    rightSlideAble() {
      return this.content + this.slideWidth > this.container;
    },
    leftSlideAble() {
      return this.slideWidth < 0;
    },
    itemStyle() {
      const translateType = 'translateX';
      const value = `${translateType}(${this.slideWidth}px)`;
      const style = {
        transform: value
      };
      return style;
    },
    computedSlideWidth() {
      return this.onceSlideWidth || this.container;
    }
  },
  data() {
    return {
      index: 0,
      container: 0,
      content: 0,
      slideWidth: 0
    };
  },
  methods: {
    leftSlide() {
      this.index = 0;
      if (!this.leftSlideAble) return;
      this.slideWidth += this.computedSlideWidth;
    },
    rightSlide() {
      this.index = 1;
      if (!this.rightSlideAble) return;
      this.slideWidth -= this.computedSlideWidth;
    }
  },
  created() {
    this.throttledArrowLeftClick = debounce(
      () => {
        this.leftSlide();
      },
      300,
      { leading: true, trailing: false }
    );
    this.throttledArrowRightClick = debounce(
      () => {
        this.rightSlide();
      },
      300,
      { leading: true, trailing: false }
    );
  },
  mounted() {
    this.container = this.$refs.slideWrap.offsetWidth;
    this.content = this.$refs.contentWrap.offsetWidth;
  }
};
</script>

<style lang="scss" scoped>
.padding {
  position: relative;
  overflow: hidden;
}
.slide__wrap {
  position: relative;
  overflow: hidden;
  .content__wrap {
    width: fit-content;
    position: relative;
    display: flex;
    overflow: hidden;
    transition: transform 1s ease;
  }
}
.arrow__left,
.arrow__right {
  position: absolute;
  width: 38px;
  height: 46px;
  color: #ffffff;
  font-size: 24px;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.15;
  cursor: pointer;
  transition: 0.3;
  background: #000000;
  border-radius: 0px 188px 188px 0px;
  &:hover {
    opacity: 0.4;
  }
  &.disabled {
    opacity: 0.15;
  }
  i {
    position: relative;
    line-height: 46px;
  }
}
.arrow__left {
  left: 0;
}
.arrow__right {
  right: 0;
  border-radius: 188px 0px 0px 188px;
  i {
    left: 4px;
  }
}
</style>
